module.exports = __webpack_public_path__ + "static/media/fa-solid-900.fadfeaf3.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/fa-solid-900.woff2
// module id = 771
// module chunks = 0